import '@babel/polyfill';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Router } from 'react-router-dom';
import Helmet from 'react-helmet';
import { createBrowserHistory } from 'history';
import { store } from './redux/store';
import './css/base.css';
import './css/sprites.css';
import './css/railEnhancements.css';
import './index.css';

import IRCTCCaptchaPage from './components/IRCTCCaptchaPage/IRCTCCaptchaPageContainer';
import RetrievePassword from './components/IRCTCCaptchaPageFailures/RetrievePasswordContainer';
import PaymentTimeOut from './components/PaymentTimeOut/PaymentTimeOut';
import CreateNewAccount from './pages/createNewAccount/CreateNewAccount';
import {
  RAIL_SEO_LISTING_PATH,
  RAIL_LISTING_PATH,
  RAIL_LEGACY_LISTING_PATH,
  RAIL_MWEB_LISTING_PATH,
  RAIL_REVIEW_PATH,
  RAIL_THANK_YOU_PATH,
  RAIL_LEGACY_THANK_YOU_PATH,
  RAIL_CAPTCHA_PATH,
  RAIL_LEGACY_CAPTCHA_PATH,
  RAIL_RETRIEVE_PWD_PATH,
  RAIL_LEGACY_RETRIEVE_PWD_PATH,
  RAIL_PAYMENT_TIMEOUT_PATH,
  RAIL_LEGACY_PAYMENT_TIMEOUT_PATH,
  RAIL_CREATE_NEW_ACCOUNT_PATH,
  RAIL_NEED_HELP_PATH,
  MMT_FAVICON,
  FONTS,
} from './constants/URLconstants';
import { RAILS_SESSION_ID_KEY } from './constants/TrainConstants';
import axios from 'axios';
import storagePolyfill from "./utils/storageUtil";
import ConnectedHeader from "./ConnectedHeader";
import NeedHelp from './pages/needHelp';
import { fetchAbConfig, fetchAbConfigLocalStorage } from "./redux/actions/AbConfigActions";
import { getSessionID } from './utils/interceptorUtils';
import { SERVER_URL } from './constants/ClientConfig';
import {getConfigKey, ENABLE_CLARITY_CFGKEY } from './utils/configStore';
import { injectClarityScript } from './utils/qubitWebHelper';
import { handleCssForMyBiz } from './utils/BizUtils';
import { MAKE_MY_TRIP_TRAINS, POKUS_WEB_LOCAL_STORAGE_KEY, RAIL_RAIL_BOOKING } from './constants/Constants';
import Loader from './Loader';

storagePolyfill && storagePolyfill();

try {
  Raven.config('https://81fa4f5d8802473299d578c4fdbdde40@bugs.goibibo.com/144').install();
} catch (e) {
  console.error('error while loading raven', e);
}

const Listing = lazy(() => import('./pages/listing/Listing'))
const TravellersDetails = lazy(() => import('./pages/travellersDetails/TravellersDetails'))
const ThankYou = lazy(() => import('./pages/thankYou/pages/ThankYouPage'))
const SEOListing = lazy(() => import('./pages/listing/SEOListing'))
const history = createBrowserHistory();
handleCssForMyBiz();

axios.defaults.headers.common['mmt-os'] = 'desktop';
axios.interceptors.request.use(
  request => {
    if (request.url.includes(SERVER_URL))
      request.headers[RAILS_SESSION_ID_KEY] = getSessionID();
    return request;
  },
  error => Promise.reject(error)
)

getConfigKey(ENABLE_CLARITY_CFGKEY, false).then((response) => {
  if(response) {
    injectClarityScript();
  }
});

const App = () => {
  const [loading, setLoading] = useState(true);
 
  useEffect(() => {
    const fetchConfig = async () => {
      await store.dispatch(fetchAbConfig());
      setLoading(false);
    };
    if(localStorage.getItem(POKUS_WEB_LOCAL_STORAGE_KEY)){
      store.dispatch(fetchAbConfigLocalStorage());
      setLoading(false);
    }
    else{
      fetchConfig();
    }
  }, []);
 
  if (loading) {
   return <Loader />;
  }
  return (<div>
    <Helmet>
      <meta charSet="UTF-8" />
      <meta name="Description" content="Rail" />
      <title>{MAKE_MY_TRIP_TRAINS}</title>
      <meta content="text/html; charset=utf-8" />
      <meta content="" />
      <meta content={RAIL_RAIL_BOOKING} />
      <link rel="icon" href={MMT_FAVICON} />
      <link href={FONTS} rel="stylesheet" />
    </Helmet>
    <Provider store={store}>
      <ConnectedHeader />
      <Router history={history}>
        <Switch>
          <Suspense fallback={<Loader />}>
            <Route path={RAIL_SEO_LISTING_PATH} exact component={SEOListing} />
            <Route path={RAIL_LISTING_PATH} exact component={Listing} />
            <Route path={RAIL_MWEB_LISTING_PATH} exact component={Listing} />
            <Route path={RAIL_LEGACY_LISTING_PATH} exact component={Listing} />
            <Route path={RAIL_REVIEW_PATH} exact component={TravellersDetails} />
            <Route path={RAIL_THANK_YOU_PATH} exact component={ThankYou} />
            <Route path={RAIL_LEGACY_THANK_YOU_PATH} exact component={ThankYou} />
            <Route path={RAIL_CAPTCHA_PATH} exact component={IRCTCCaptchaPage} />
            <Route path={RAIL_LEGACY_CAPTCHA_PATH} exact component={IRCTCCaptchaPage} />
            <Route path={RAIL_RETRIEVE_PWD_PATH} exact component={RetrievePassword} />
            <Route path={RAIL_LEGACY_RETRIEVE_PWD_PATH} exact component={RetrievePassword} />
            <Route path={RAIL_PAYMENT_TIMEOUT_PATH} exact component={PaymentTimeOut} />
            <Route path={RAIL_LEGACY_PAYMENT_TIMEOUT_PATH} exact component={PaymentTimeOut} />
            <Route path={RAIL_CREATE_NEW_ACCOUNT_PATH} exact component={CreateNewAccount} />
            <Route path={RAIL_NEED_HELP_PATH} exact component={NeedHelp} />
          </Suspense>
        </Switch>
      </Router>
    </Provider>
  </div>);
};

ReactDOM.render(<App />, document.getElementById('root'));
